import { CircularProgress, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import Button from "@mui/material/Button";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import axios from "axios";
import Chip from "@mui/material/Chip";
import IndexedDBService, { storeName } from "../../Utils/DBConfig";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { setBookList, setCharList, serRachiytaList, setKirtanList, setBhavList } from "../../Slice/formSlice";
import { setKirtanIndex } from "../../Slice/KirtanIndexSlice";
import handleContent from "../../services/kirtanContent.service";
import api from "../../Utils/Interceptor";

const SearchPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [page_no, setPageNo] = useState(0);
  const [loaderEffect, setLoaderEffect] = useState(false);
  const [kirtanData, setKirtanData] = useState([]);
  let oldLocation = "";
  if (state) {
    oldLocation = state.oldLocation;
  }

  const [filterData, setFilterData] = useState({
    kirtan_title: "",
    book_name: "",
    char_name: "",
    bhav_name: "",
    page_no: "",
  });

  const isDbInitialized = useSelector((state) => state.db.isDbInitialized);
  const bookList = useSelector((state) => state.FormList.book_list);
  const charList = useSelector((state) => state.FormList.char_list);
  const kirtanList = useSelector((state) => state.FormList.kirtan_list);
  const bhavList = useSelector((state) => state.FormList.bhav_list);
  const APIurl = useSelector((state) => state.db.url);

  const handleReset = () => {
    setFilterData({
      kirtan_title: "",
      book_name: "",
      char_name: "",
      bhav_name: "",
      page_no: "",
    });
    setPageNo(0);
  };

  const handleBackWord = () => {
    if (state) {
      oldLocation = state.oldLocation;
      if (oldLocation === "main") navigate("/");
      else navigate(`/${oldLocation}`);
    }
  };

  const handleCharNameChange = (event, newAlignment) => {
    const value = newAlignment === null ? "" : newAlignment;
    setFilterData((previous) => {
      return { ...previous, char_name: value };
    });
    setPageNo(0);
  };

  const handleBhavNameChange = (event, newAlignment) => {
    const value = newAlignment === null ? "" : newAlignment;
    setFilterData((previous) => {
      return { ...previous, bhav_name: value };
    });
    setPageNo(0);
  };

  const handleBookNameChange = (event, newAlignment) => {
    const value = newAlignment === null ? "" : newAlignment;
    setFilterData((previous) => {
      return { ...previous, book_name: value };
    });
    setPageNo(0);
  };

  const handleTitleChange = (event) => {
    setFilterData((previous) => {
      return { ...previous, kirtan_title: `${event.target.value}` };
    });
    setPageNo(0);
  };

  const handlePageNoChange = (event) => {
    setFilterData((previous) => {
      return { ...previous, page_no: `${event.target.value}` };
    });
    setPageNo(0);
  };

  const findBookShortName = (id) => {
    const book = bookList?.find((book) => book.id === id);
    return book ? book.short_code : null;
  };

  const findBookIdArr = (bookNameArr) => {
    const bookIdArr = bookNameArr.map((bookName) => {
      const bookObject = bookList?.find((obj) => obj.name === bookName);
      return bookObject ? bookObject.id : null;
    });
    return bookIdArr ? bookIdArr : [];
  };

  const findCharIdArr = (charNameArr) => {
    const charIdArr = charNameArr.map((charName) => {
      const charObject = charList?.find((obj) => obj.guj_char === charName);
      return charObject ? charObject.id : null;
    });
    return charIdArr ? charIdArr : [];
  };

  const findBhavIdArr = (bhavNameArr) => {
    const bhavIdArr = bhavNameArr.map((bhavName) => {
      const bhavObject = bhavList?.find((obj) => obj.bhav_name === bhavName);
      return bhavObject ? bhavObject.id : null;
    });
    return bhavIdArr ? bhavIdArr : [];
  };

  const masterData = async () => {
    const url = `${APIurl}/api/kirtan/masterData-list`;
    const res = await api.get(url);
    const dataList = res.data.data;
    dispatch(setBookList(dataList.book_list));
    dispatch(setCharList(dataList.char_list));
    dispatch(serRachiytaList(dataList.rachiyta_list));
    dispatch(setBhavList(dataList.bhav_list));
  };

  const handleScroll = () => {
    const box = document.getElementById("yourBoxId");
    if (box.scrollTop + box.clientHeight >= box.scrollHeight && !loaderEffect) {
      setPageNo((pres) => pres + 1);
      setLoaderEffect(true);
    }
  };

  function extractStyle(html) {
    const regex = /<span\s+[^>]*?style="([^"]*font-family:[^"]*?;[^"]*color:[^"]*?)"[^>]*>/i;
    const match = html.match(regex);
    return match ? match[0] : "";
  }

  const handleSelectedKirtanId = async (kirtan_id) => {
    const SelectedKirtanUrl = `${APIurl}/api/kirtan/id/${kirtan_id}`;
    // await fetch(SelectedKirtanUrl).then((res) => {
    //     return res.json();
    // }).
    const authToken = sessionStorage.getItem("token");
    await axios
      .get(SelectedKirtanUrl, {
        headers: {
          Authorization: authToken ? `Bearer ${authToken}` : "",
        },
      })
      .then((fetchData) => {
        if (oldLocation === "kirtan-data") {
          navigate("/kirtan-data", {
            state: {
              flag: true,
              data: fetchData.data.data,
            },
          });
        } else if (oldLocation === "main") {
          const finalKirtan = fetchData.data.data;
          const finalContent = handleContent(finalKirtan.content);
          const maxOrder = kirtanData.length > 0 ? Math.max(...kirtanData.map((k) => k.order || 0)) : 0;
          const dbData = {
            id: kirtanData.length > 0 ? kirtanData[kirtanData.length - 1]?.id + 1 : 0,
            title: finalKirtan.unicode_title,
            english_title: finalKirtan.english_title || "",
            content: finalContent,
            shortcuts: {
              0: "1",
              1: "2",
              2: "3",
              3: "4",
              4: "5",
              5: "6",
              6: "7",
              7: "8",
              8: "9",
            },
            seq_id: finalKirtan.seq_id || 0,
            book_id: finalKirtan.book_id || 0,
            database_id: finalKirtan.id || 0,
            originalContent: finalKirtan.content,
            settings: {
              fontFamily: "Guj_Gopika_Two_Bold",
              fontSize: "50px",
              fontWeight: "500",
              color: "#ffffff",
              backgroundColor: "#000000",
              height: "100px",
              textShadowColor: "#ffffff",
              textShadowWidth: "0px",
              isDualLineMode: false,
            },
            favLines: [0, 1],
            lineHistory: [],
            selectedLine: 0,
            selectedPlate: 1,
            order: maxOrder + 1,
          };

          if (isDbInitialized) {
            IndexedDBService.addItem(dbData, storeName)
              .then(() => {
                dispatch(setKirtanIndex(dbData.id));
                navigate("/");
              })
              .catch((error) => console.error(error));
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleFilterChange = async (filterData, change) => {
    let queryString = "?";
    let counter = 0;
    let page = page_no;
    if (filterData.kirtan_title.length > 0) {
      queryString += `kirtan_title=${filterData.kirtan_title}`;
      counter++;
    }
    if (filterData.book_name.length > 0) {
      if (counter !== 0) {
        queryString += "&";
      }
      queryString += `book_id=${findBookIdArr(filterData.book_name)}`;
      counter++;
    }
    if (filterData.bhav_name.length > 0) {
      if (counter !== 0) {
        queryString += "&";
      }
      queryString += `bhav_id=${findBhavIdArr(filterData.bhav_name)}`;
      counter++;
    }

    if (filterData.char_name.length > 0) {
      if (counter !== 0) {
        queryString += "&";
      }
      queryString += `char_id=${findCharIdArr(filterData.char_name)}`;
      counter++;
    }

    if (filterData.page_no.length > 0) {
      if (counter !== 0) {
        queryString += "&";
      }
      queryString += `page_no=${filterData.page_no}`;
      counter++;
    }
    if (counter === 0) {
      queryString = ``;
    }
    if (counter !== 0) {
      queryString += `&page=${page}&limit=${50}`;
    } else {
      queryString += `?page=${page}&limit=${50}`;
    }
    try {
      if (change) {
        page = 0;
      }
      const url = `${APIurl}/api/kirtan/filterList${queryString}`;
      const res = await api.get(url);
      const dataList = res.data.data;
      if (change) {
        dispatch(setKirtanList(dataList.length > 0 ? dataList : []));
      } else {
        dispatch(setKirtanList(dataList.length > 0 ? [...kirtanList, ...dataList] : kirtanList));
      }

      setLoaderEffect(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleFilterChange(filterData, false);
  }, [page_no]);
  useEffect(() => {
    masterData();
    handleFilterChange({ kirtan_title: "", book_name: "", char_name: "", bhav_name: "", page_no: "" }, false);
  }, []);

  useEffect(() => {
    handleFilterChange(filterData, true);
  }, [filterData]);

  useEffect(() => {
    isDbInitialized && IndexedDBService.getAllData(storeName).then((data) => setKirtanData(data));
  }, [isDbInitialized]);
  return (
    <>
      <Box className="h-screen w-screen overflow-hidden z-50">
        <Box className="grid grid-cols-2 grid-rows-1 h-full p-4 overflow-hidden gap-4 content-center">
          <Box className="flex flex-col w-full shadow-lg rounded-2xl px-4 py-4 overflow-auto gap-5 justify-between bg-[#fdf4e1]">
            <Box className="my-2 flex gap-2">
              <Box className="w-full">
                <label className="font-bold text-base mb-2">Kirtan :</label>
                <TextField
                  className="w-full bg-white"
                  sx={{ borderRadius: "999px" }}
                  value={filterData.kirtan_title}
                  InputProps={{
                    style: {
                      fontSize: "16px",
                      borderRadius: "9999px",
                    },
                  }}
                  autoComplete="off"
                  size="small"
                  onChange={handleTitleChange}
                  id="filled-basic"
                />
              </Box>
              <Box className="w-full">
                <label className="font-bold text-base mb-2">Page No :</label>
                <TextField
                  value={filterData.page_no}
                  sx={{
                    borderRadius: "999px",
                    "& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button": {
                      "-webkit-appearance": "none",
                      margin: 0,
                    },
                    "& input[type=number]": {
                      "-moz-appearance": "textfield", // Firefox
                    },
                  }}
                  InputProps={{
                    style: {
                      fontSize: "16px",
                      borderRadius: "9999px",
                    },
                    inputProps: {
                      onWheel: (event) => event.currentTarget.blur(),
                    },
                  }}
                  autoComplete="off"
                  className="w-full bg-white"
                  size="small"
                  onChange={handlePageNoChange}
                  type="number"
                  id="filled-basic"
                />
              </Box>
            </Box>
            <Box className="my-2 grid grid-flow-row ">
              <ToggleButtonGroup
                className="flex justify-start items-center gap-3 "
                style={{ flexWrap: "wrap" }}
                color="primary"
                value={filterData.book_name}
                onChange={handleBookNameChange}
                aria-label="Kirtan selection"
              >
                {bookList &&
                  bookList.map((book) => (
                    <ToggleButton
                      size="small"
                      key={book.name}
                      className="w-[160px]"
                      sx={{
                        fontWeight: "700",
                        border: "2px solid transparent",
                        color: "black",
                        backgroundColor: "#ffffff",
                        borderRadius: "5px !important",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: "#e1e4e0",
                          color: "black",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#ffffff",
                          color: "black", // Text color when selected
                          border: "2px solid #2196f3",
                          borderLeft: "2px solid #2196f3 !important",
                        },
                      }}
                      value={book.name}
                    >
                      {book.name}
                    </ToggleButton>
                  ))}
              </ToggleButtonGroup>
            </Box>
            <Box className="my-2 grid grid-flow-row">
              <ToggleButtonGroup
                className="flex justify-start items-center"
                style={{ flexWrap: "wrap" }}
                color="primary"
                value={filterData.char_name}
                onChange={handleCharNameChange}
                aria-label="Kirtan selection"
              >
                {charList &&
                  charList.map((char) => (
                    <ToggleButton
                      size="small"
                      key={char.guj_char}
                      className="border m-1 w-[35px] rounded"
                      sx={{
                        fontWeight: "700",
                        border: "2px solid transparent !important",
                        color: "black",
                        backgroundColor: "#ffffff",
                        borderRadius: "5px",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: "#e1e4e0",
                          color: "black",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#ffffff",
                          color: "black", // Text color when selected
                          border: "2px solid #2196f3 !important",
                          borderLeft: "2px solid #2196f3 !important",
                        },
                      }}
                      value={char.guj_char}
                    >
                      {char.guj_char}
                    </ToggleButton>
                  ))}
              </ToggleButtonGroup>
            </Box>
            <Box className="my-2 grid grid-flow-row">
              <ToggleButtonGroup
                className="flex justify-start items-center gap-3"
                style={{ flexWrap: "wrap" }}
                color="primary"
                value={filterData.bhav_name}
                onChange={handleBhavNameChange}
                aria-label="Kirtan selection"
              >
                {bhavList &&
                  bhavList.map((bhav) => (
                    <ToggleButton
                      size="small"
                      key={bhav.bhav_name}
                      className="w-[160px] rounded"
                      sx={{
                        fontWeight: "700",
                        border: "2px solid transparent",
                        color: "black",
                        backgroundColor: "#ffffff",
                        borderRadius: "5px",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: "#e1e4e0",
                          color: "black",
                        },
                        "&.Mui-selected": {
                          backgroundColor: "#ffffff",
                          color: "black", // Text color when selected
                          border: "2px solid #2196f3",
                          borderLeft: "2px solid #2196f3 !important",
                        },
                      }}
                      value={bhav.bhav_name}
                    >
                      {bhav.bhav_name}
                    </ToggleButton>
                  ))}
              </ToggleButtonGroup>
            </Box>
            <Box className={`flex flex-row justify-center items-center w-full p-[2px] gap-2 mt-2`}>
              <Button
                className="w-[152px]"
                sx={{ borderRadius: "9999px", textTransform: "none" }}
                variant="contained"
                color="primary"
                onClick={handleBackWord}
              >
                Back
              </Button>
              <Button
                className="w-[152px]"
                sx={{ borderRadius: "9999px", textTransform: "none" }}
                variant="contained"
                color="primary"
                onClick={handleReset}
              >
                Reset
              </Button>
            </Box>
          </Box>
          <Box
            id="yourBoxId"
            className="relative w-full flex flex-col shadow-lg rounded-2xl p-4 overflow-auto bg-[#fdf4e1] gap-2 py-9"
            onScroll={handleScroll}
          >
            <Button
              className="h-[40px] z-10 p-0 shadow-lg bg-white"
              sx={{
                borderRadius: "999px",
                minWidth: "40px",
                maxWidth: "40px",
                position: "absolute",
                top: "10px", // Adjust this value as needed
                right: "10px",
              }}
              onClick={handleBackWord}
            >
              <i className="fa-regular fa-circle-xmark fa-2xl text-red-600"></i>
            </Button>
            <div className="mt-2 w-full"></div>
            {kirtanList.length > 0 &&
              kirtanList.map((kirtan) => {
                return (
                  <Stack
                    className={`w-full flex justify-center items-center transition-all duration-300 ease-in-out cursor-pointe bg-inherit cursor-pointer no-select`}
                    direction={{ xs: "column", sm: "row" }}
                    spacing={{ xs: 1, sm: 2, md: 4 }}
                    onDoubleClick={() => handleSelectedKirtanId(kirtan.id)}
                  >
                    {findBookShortName(kirtan.book_id) && (
                      <div className="justify-center items-center w-full grid grid-cols-3" style={{ gridTemplateColumns: "5fr 35fr 1fr" }}>
                        {kirtan?.book_id && (
                          <div className={`inline transition-all duration-300 ease-in-out opacity-100`}>
                            <Chip
                              label={`#${findBookShortName(kirtan.book_id)}-${kirtan.seq_id} `}
                              className="text-lg text-black"
                              style={{ fontFamily: '"Roboto","Helvetica","Arial",sans-serif', backgroundColor: "#ffffff" }}
                            />
                          </div>
                        )}
                        <div className="text-2xl text-center" style={{ fontFamily: "Guj_Gopika_Two_Bold" }}>
                          {`${kirtan.title}`}
                        </div>

                        {kirtan.pad_no && (
                          <div className={`text-xl font-semibold opacity-100`}>
                            {kirtan.pad_no !== 1 ? (
                              <Chip
                                label={`${kirtan.pad_no}`}
                                className="text-lg p-1 text-black"
                                style={{ fontFamily: '"Roboto","Helvetica","Arial",sans-serif', backgroundColor: "#ffffff" }}
                              />
                            ) : (
                              <></>
                            )}
                          </div>
                        )}
                      </div>
                    )}
                  </Stack>
                );
              })}
            {loaderEffect && (
              <Stack
                className={`w-full flex justify-center items-center transition-all duration-300 ease-in-out cursor-pointe bg-inherit cursor-pointer no-select`}
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 1, sm: 2, md: 4 }}
              >
                {
                  <div className="w-full text-2xl text-center mb-3">
                    <CircularProgress />
                  </div>
                }
              </Stack>
            )}
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default SearchPage;
